module.exports = __webpack_public_path__ + "img/SMR.cf27f002.svg";